import { shareNative, type NativeShareResult } from "./nativeShare";
import { downloadCtaLine, PLAY_STORE_URL } from "./shareCopy";

const FROM_KEY = "uptInviteFrom";

export function buildShareUrl(_displayName: string): string {
  return PLAY_STORE_URL;
}

export function buildShareText(displayName: string): string {
  const name = displayName.trim() || "a friend";
  return (
    `${name} ne tumhe Ultimate Piano Tutor invite kiya! 🎹\n\n` +
    `Classic piano asani se seekho — Campaign, MIDI, exams & certificate.\n\n` +
    `${downloadCtaLine()}\n\n` +
    `#UltimatePianoTutor #LearnPiano`
  );
}

export async function shareAppInvite(displayName: string): Promise<NativeShareResult> {
  const text = buildShareText(displayName);
  return shareNative({
    title: "Ultimate Piano Tutor",
    text,
    url: PLAY_STORE_URL,
  });
}

/** Soft attribution: remember ?from= and strip from the URL. */
export function consumeInviteParam(onInvite?: (from: string) => void): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const from = params.get("from")?.trim();
    if (from) {
      sessionStorage.setItem(FROM_KEY, from);
      onInvite?.(from);
    }
    params.delete("from");
    const next = `${window.location.pathname}${params.toString() ? `?${params}` : ""}${window.location.hash}`;
    window.history.replaceState({}, "", next);
  } catch {
    /* ignore */
  }
}

export function getStoredInviteFrom(): string | null {
  try {
    return sessionStorage.getItem(FROM_KEY);
  } catch {
    return null;
  }
}
